import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  useTheme,
  useMediaQuery,
  Badge,
} from '@mui/material';
import AuthContext from '../contexts/AuthContext';

function DrawerContent(props) {
  const { user } = useContext(AuthContext);
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // Debug logging
  console.log('DrawerContent - User:', user);
  console.log('DrawerContent - Menu Items:', props.menuItems);
  console.log('DrawerContent - Current Location:', location.pathname);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Box sx={{ flexGrow: 1 }}>
        <List>
          {props.menuItems && props.menuItems.map((item) => {
            const isSelected = location.pathname === item.path;
            return (
              <ListItem disablePadding key={item.path}>
                <ListItemButton
                  component={Link}
                  to={item.path}
                  selected={isSelected}
                  onClick={() => console.log('Navigating to:', item.path)}
                >
                  <ListItemIcon>
                    {item.badgeContent > 0 ? (
                      <Badge badgeContent={item.badgeContent} color="error">
                        {item.icon}
                      </Badge>
                    ) : (
                      item.icon
                    )}
                  </ListItemIcon>
                  <ListItemText primary={item.text} />
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
      </Box>
    </Box>
  );
}

export default DrawerContent; 
